import React, { useState } from 'react';
import cx from 'classnames';
import { PlusIcon, MinusIcon } from '@heroicons/react/24/outline';
import PropTypes from 'prop-types';
import { onEnterSpacePress } from '@utils/keyboard';

export default function FooterAccordion({
  HeaderElement,
  className,
  children
}) {
  const [isOpen, setIsOpen] = useState(false);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  const iconClasses = cx(
    'flex',
    'self-center',
    'mr-[18px]',
    'icon',
    'h-[30px]',
    'w-[30px]',
    'lg:hidden'
  );

  return (
    <div className={`${className}`} data-testid='footer accordion'>
      <summary
        className='flex justify-between cursor-pointer lg:cursor-auto'
        onClick={toggleAccordion}
        onKeyDown={onEnterSpacePress(toggleAccordion)}
        role='button'
        tabIndex={0}
      >
        {HeaderElement}
        {isOpen ? (
          <MinusIcon className={iconClasses} />
        ) : (
          <PlusIcon className={iconClasses} />
        )}
      </summary>
      <div
        className={`${
          isOpen ? 'flex flex-col pt-3' : 'hidden lg:block'
        } transition-all`}
      >
        {children}
      </div>
    </div>
  );
}

FooterAccordion.propTypes = {
  HeaderElement: PropTypes.element.isRequired,
  className: PropTypes.string,
  children: PropTypes.array.isRequired
};

FooterAccordion.defaultProps = {
  className: ''
};
